import { type GeoJSONSource, type Map } from "maplibre-gl";
import { toValue, type MaybeRefOrGetter } from "vue";

const SOURCE = "berlin-electoral-districts";
const DATA = "/berlin-wahlkreise-ah2026.geojson";
const FILL = "berlin-electoral-districts-fill";
const OUTLINE = "berlin-electoral-districts-outline";
const LABEL = "berlin-electoral-districts-label";

export function useElectoralDistricts(mapInstance: MaybeRefOrGetter<Map>) {
  let loaded = false;

  // Start with an empty source so opening the editor stays cheap; the actual
  // GeoJSON is loaded lazily via setData on first toggle.
  const map = toValue(mapInstance);

  map.addSource(SOURCE, {
    type: "geojson",
    data: { type: "FeatureCollection", features: [] },
    attribution: "© Amt für Statistik Berlin-Brandenburg (CC BY)",
  });
  map.addLayer({
    id: FILL,
    type: "fill",
    source: SOURCE,
    layout: { visibility: "none" },
    paint: { "fill-color": "#2563eb", "fill-opacity": 0.12 },
  });
  map.addLayer({
    id: OUTLINE,
    type: "line",
    source: SOURCE,
    layout: { visibility: "none" },
    paint: { "line-color": "#1d4ed8", "line-width": 1.5 },
  });
  map.addLayer({
    id: LABEL,
    type: "symbol",
    source: SOURCE,
    layout: {
      visibility: "none",
      "text-field": ["get", "name"],
      "text-size": 12,
    },
    paint: {
      "text-color": "#1e3a8a",
      "text-halo-color": "#ffffff",
      "text-halo-width": 1.5,
    },
  });

  function toggle(visible: boolean) {
    const map = toValue(mapInstance);
    if (visible && !loaded) {
      // Fetch the ~1 MB GeoJSON only once the layer is first enabled.
      (map.getSource(SOURCE) as GeoJSONSource).setData(DATA);
      loaded = true;
    }
    [FILL, OUTLINE, LABEL].forEach((id) =>
      map.setLayoutProperty(id, "visibility", visible ? "visible" : "none"),
    );
  }

  return { toggle };
}
